export interface TranslatedString {
    default: string;
    translations?: { [lang: string]: string };
}

export function translateString(translatedString: TranslatedString | undefined, fallbackLanguage?: string): string | undefined {
    if (!translatedString) {
        return undefined;
    }

    if (!translatedString?.translations) {
        return translatedString.default;
    }

    // Check for translations in the order of languages
    const languages = getLanguages();
    for (const lang of languages) {
        if (translatedString.translations[lang]) {
            return translatedString.translations[lang];
        }
    }

    // Fallback to english (en)
    if (translatedString.translations[fallbackLanguage || 'en']) {
        return translatedString.translations[fallbackLanguage || 'en'];
    }

    return translatedString.default
}

export function getLanguages(): Array<string> {
    let browserLang: string[] | undefined = window.navigator?.languages as string[];
    // @ts-expect-error browserLang and userLanguage might not be defined in some environments
    browserLang = browserLang || [window.navigator.language] || [window.navigator.browserLanguage] || [window.navigator.userLanguage] || ['en'];

    // normalize e.g.: en-US to en or de_DE to de
    browserLang = browserLang.map(s => s.split('-')[0]);
    browserLang = browserLang.map(s => s.split('_')[0]);

    // remove duplicates keep the first one
    browserLang = Array.from(new Set(browserLang));

    return browserLang;
}
